import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Row, Col, Divider, Tag, Icon, Modal } from 'antd'
import debounce from 'lodash/debounce'
import Card from 'components/Card'
import GLayout from 'components/layout/GuessLayout'
import CardLayout from 'components/layout/CardLayout'
import { timeFormat } from 'util/utils'
import styles from './index.scss'
import { History } from '../../../../node_modules/@types/history'

type Praise = {
  count: number
  hasPraise: 0 | 1
}
type Collect = {
  collectCount: number
  hasCollect: 0 | 1
}
interface Props {
  id: number
  content: any
  color: string[]
  guess: any[]
  related?: any[]
  collect?: Collect
  praise?: Praise
  articleLike: React.EventHandler<any>
  articleCollect: React.EventHandler<any>
  history?: History
}
interface State {
  id: number
  page: number
  previewImg: string
  visible: boolean
}

class CourseArticle extends ComponentExt<Props, State> {
  private timer

  constructor(props) {
    super(props)
    this.state = {
      id: undefined,
      page: 1,
      previewImg: '',
      visible: false,
    }
    this.studying = debounce(this.studying.bind(this), 300)
  }

  componentDidMount() {}

  componentDidUpdate() {
    document
      .getElementById('body-content')
      .removeEventListener('click', this.handleImg)
    document
      .getElementById('body-content')
      .addEventListener('click', this.handleImg)
    if (this.props.content.random) {
      if (this.timer) {
        return
      }
      this.studying()
    }
  }

  componentWillUnmount() {
    document
      .getElementById('body-content')
      .removeEventListener('click', this.handleImg)
    clearTimeout(this.timer)
  }

  async studying() {
    const { id, content } = this.props
    await this.api.article.statistics(id, content.random)

    this.timer = setTimeout(() => {
      this.studying()
    }, 60000)
  }

  handleImg = e => {
    const pic = e.target
    if (pic.tagName === 'IMG') {
      this.setState({
        previewImg: pic.src,
        visible: true,
      })
    }
  }

  async likeAnswer(id) {
    try {
      await this.api.article.likeAnswer(id)
      console.log('点赞成功')
    } catch (err) {
      this.$message.error(err.message)
    }
  }

  async unlikeAnswer(id) {
    try {
      await this.api.article.unlikeAnswer(id)
      console.log('取消点赞成功')
    } catch (err) {
      this.$message.error(err.message)
    }
  }

  // onlike = (id, idx, islike) => {
  //   const list = this.state.commentList
  //   switch (islike) {
  //     case 0:
  //       list[idx].has_praise = 1
  //       list[idx].praise_count += 1
  //       this.likeAnswer(id)
  //       break
  //     case 1:
  //       list[idx].has_praise = 0
  //       list[idx].praise_count -= 1
  //       this.unlikeAnswer(id)
  //       break
  //   }
  //   this.setState({
  //     commentList: list,
  //   })
  // }

  handleCancel = () =>
    this.setState({
      visible: false,
      previewImg: '',
    })

  toDetail = (id, type, content?) => {
    if (type === '1000105') {
      return window.open(content, '_blank')
    }
    window.open(`#/course/${id}?type=${type}`)
  }

  render() {
    const {
      content,
      color,
      guess,
      related,
      praise,
      collect,
      articleLike,
      articleCollect,
    } = this.props
    const { previewImg } = this.state
    const isCollect = Boolean(collect.hasCollect)
    const isPraise = Boolean(praise.hasPraise)

    const previewPic = url => (
      <Modal
        visible={this.state.visible}
        destroyOnClose
        footer={null}
        width={1000}
        onCancel={this.handleCancel}
      >
        <img src={url} style={{ width: '100%' }} />
      </Modal>
    )

    const tagRender = (arr, _color) => {
      return (
        arr &&
        arr.map(({ id, label_name }, idx) => (
          <Tag key={`tag-${id}`} color={_color[idx]}>
            {label_name}
          </Tag>
        ))
      )
    }

    const collectBtn = (
      <div onClick={articleCollect.bind(null)} className={styles.likebutton}>
        <Icon
          type={isCollect ? 'star' : 'star-o'}
          style={{ color: isCollect && '#FF3C00', fontSize: 18 }}
        />
        <span>
          {isCollect ? '已收藏' : `${collect.collectCount || 0}人收藏`}
        </span>
      </div>
    )

    const likeBtn = (
      <div onClick={articleLike.bind(null)} className={styles.likebutton}>
        <Icon
          type={isPraise ? 'like' : 'like-o'}
          style={{ color: isPraise && '#FF3C00', fontSize: 18 }}
        />
        <span>{`${praise.count || 0}人点赞`}</span>
      </div>
    )

    const guessItem = (idx, { id, title, type, view_count }) => (
      <div
        key={idx}
        className={styles.guessItem}
        onClick={() => this.toDetail(id, type)}
      >
        <div className={styles.guessItemNum}>
          {(Array(2).join('0') + ++idx).slice(-2)}
        </div>
        <div className={styles.guessItemBody}>
          <div className={styles.guessItemTitle}>{title}</div>
          <div className={styles.guessItemDesc}>{view_count}人学过</div>
        </div>
      </div>
    )

    return (
      <div className={styles.article}>
        <div className={styles.articleHeader}>
          <Row gutter={16}>
            <Col span={17}>
              <div className={styles.articleHeaderInner}>
                <div className={styles.articleHeaderTitle}>
                  <span>{content.title}</span>
                </div>
                <div>
                  <span>
                    {content.publish_date && timeFormat(content.publish_date)}
                  </span>
                </div>
              </div>
            </Col>
            <Col span={7} />
          </Row>
        </div>
        <div className={styles.articleBody}>
          <Row gutter={32}>
            <Col span={17}>
              <div className={styles.articleBodyInner}>
                <div className={styles.articleBodyAuthor}>
                  <div className={styles.articleBodyAuthorLeft}>
                    <span>作者：{content.author || '-'}</span>
                    <div className={styles.articleBodyAuthorLeftCloud}>
                      {tagRender(content.labels, color)}
                    </div>
                  </div>
                  <div className={styles.articleBodyAuthorRight}>
                    <div className={styles.description}>
                      {`${content.view_count || 0}人学过`}
                    </div>
                    <div className={styles.description}>{likeBtn}</div>
                    <div className={styles.description}>{collectBtn}</div>
                  </div>
                </div>
                <Divider />
                <div
                  id="body-content"
                  className={styles.articleBodyContent}
                  dangerouslySetInnerHTML={{ __html: content.content }}
                />
                {previewPic(previewImg)}
              </div>
              <CardLayout style={{ marginTop: 16 }} title="相关课程">
                <div className={styles.relate}>
                  {related &&
                    related.map(
                      (
                        {
                          id,
                          title,
                          img_url,
                          view_count,
                          course_time,
                          type: _type,
                        },
                        idx,
                      ) => (
                        <Card
                          key={id || idx}
                          dataType={_type}
                          cover={img_url}
                          title={title}
                          watch={view_count}
                          time={course_time}
                          bodyStyle={{
                            backgroundColor: '#F5F5F5',
                          }}
                          onClick={() => this.toDetail(id, _type)}
                        />
                      ),
                    )}
                </div>
              </CardLayout>
            </Col>
            <Col span={7}>
              <GLayout
                title={
                  <span
                    style={{
                      fontSize: 24,
                      fontWeight: 500,
                      color: '#333',
                    }}
                  >
                    猜你喜欢
                  </span>
                }
              >
                {guess &&
                  guess.map(
                    (
                      {
                        id,
                        title,
                        img_url,
                        view_count,
                        course_time,
                        type,
                        content: _content,
                      },
                      idx,
                    ) => (
                      <div style={{ marginBottom: 16 }}>
                        <Card
                          key={id || idx}
                          dataType={type}
                          cover={img_url}
                          title={title}
                          watch={view_count}
                          time={course_time}
                          bodyStyle={{
                            backgroundColor: '#F5F5F5',
                          }}
                          onClick={() => this.toDetail(id, type, _content)}
                        />
                      </div>
                    ),
                  )}
              </GLayout>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default CourseArticle
